import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { allCategories } from "@/utils/news";
import SearchBox from "@/components/feature/SearchBox";

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const navLinkClass =
    "whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200 hover:text-foreground-950";

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-100/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-shell items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg font-black text-foreground-950">
            9
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-wide text-foreground-950">
              911爆料
            </span>
            <span className="mt-0.5 font-label text-[10px] tracking-[0.28em] text-foreground-500">
              NEWS
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          <Link to="/" className={navLinkClass}>
            首页
          </Link>
          {allCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className={navLinkClass}
            >
              {category.name}
            </Link>
          ))}
          <Link to="/about" className={navLinkClass}>
            关于我们
          </Link>
          <Link to="/contact" className={navLinkClass}>
            联系我们
          </Link>
        </nav>

        <div className="ml-auto hidden w-72 xl:block">
          <SearchBox />
        </div>
        <Link
          to="/search"
          aria-label="搜索"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-500 hover:text-foreground-950 xl:ml-0 xl:hidden"
        >
          <i className="ri-search-line" />
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开菜单"
          aria-expanded={menuOpen}
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-lg text-foreground-800 transition-colors hover:border-primary-500 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-100 lg:hidden">
          <div className="mx-auto w-full max-w-shell px-4 py-4 md:px-6">
            <div className="mb-4">
              <SearchBox />
            </div>
            <nav className="grid grid-cols-2 gap-2" aria-label="移动端导航">
              <Link
                to="/"
                className="rounded-md bg-background-200 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                首页
              </Link>
              {allCategories.map((category) => (
                <Link
                  key={category.slug}
                  to={`/category/${category.slug}`}
                  className="rounded-md bg-background-200 px-3 py-2.5 text-sm font-medium text-foreground-800"
                >
                  {category.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="rounded-md bg-background-200 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                关于我们
              </Link>
              <Link
                to="/contact"
                className="rounded-md bg-background-200 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                联系我们
              </Link>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}